import { Rating } from '../enums/bot/rating.enum';

export const defaultRatingText = {
    [Rating.Five]: 'Very Satisfied',
    [Rating.Four]: 'Satisfied',
    [Rating.Three]: 'Neutral',
    [Rating.Two]: 'Unsatisfied',
    [Rating.One]: 'Very unsatisfied'
}